import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgShrink = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m14 10 8-8",
				"data-cap": "butt"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M21 10h-7V3" }),
			/* @__PURE__ */ _jsx("path", {
				d: "m10 14-8 8",
				"data-cap": "butt"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M10 21v-7H3" })
		]
	})
});
export default SvgKgShrink;
